import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IScheduledCampaign } from '../../data/interfaces/scheduled-campaign.interface';
import { CampaignService } from '../../data/services/view/campaign.service';

@Component({
  selector: 'app-campaign-dashboard',
  templateUrl: './campaign-dashboard.component.html',
  styleUrls: ['./campaign-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignDashboardComponent implements OnInit, OnChanges {
  @Input() campaigns: IScheduledCampaign[] = [];
  
  metrics: any = {};
  chartData: any;
  chartOptions: any;

  constructor(
    public campaignService: CampaignService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.calculateMetrics();
    this.buildChart();
  }

  ngOnChanges() {
    this.calculateMetrics();
    this.buildChart();
  }

  calculateMetrics() {
    this.metrics = this.campaignService.aggregateMetrics(this.campaigns);
  }

  buildChart() {
    this.chartData = {
      labels: ['Pendientes', 'Completadas', 'Fallidas', 'Canceladas'],
      datasets: [
        {
          data: [
            this.metrics.pending || 0,
            this.metrics.completed || 0,
            this.metrics.failed || 0,
            this.metrics.cancelled || 0
          ],
          backgroundColor: ['#FFA726', '#66BB6A', '#EF5350', '#78909C']
        }
      ]
    };
    
    this.chartOptions = {
      plugins: {
        legend: {
          position: 'bottom'
        }
      },
      responsive: true,
      maintainAspectRatio: false
    };
  }

  /**
   * Método público para forzar detección de cambios desde el componente padre
   */
  detectChanges(): void {
    this.cdr.markForCheck();
  }
}
